/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendAsEmailRequest
 */
export interface SendAsEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof SendAsEmailRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof SendAsEmailRequest
     */
    message?: string;
}

/**
 * Check if a given object implements the SendAsEmailRequest interface.
 */
export function instanceOfSendAsEmailRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;

    return isInstance;
}

export function SendAsEmailRequestFromJSON(json: any): SendAsEmailRequest {
    return SendAsEmailRequestFromJSONTyped(json, false);
}

export function SendAsEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendAsEmailRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function SendAsEmailRequestToJSON(value?: SendAsEmailRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'message': value.message,
    };
}

